"use client";

import Image from "next/image";
import { trackItemTapped } from "@/utils/mixpanel";
import { MixpanelValues } from "@/constants/mixpanel";

const AwardEmblemImage = () => {
    return (
        <Image
            id="generic-modal-trigger-award-emblem"
            src="/assets/gluten-free/gluten-free-award-emblem.svg"
            alt="Atly Logo"
            width={130}
            height={24}
            onClick={() => trackItemTapped(MixpanelValues.ItemTapped.AWARD_EMBLEM)}
        />
    );
};

export default AwardEmblemImage;
